import { useNavigate } from 'react-router-dom';

import { useShallow } from 'zustand/react/shallow';
import { useTranslation } from 'react-i18next';

import { useGradeFlow } from '@/states/grade-flow';
import { toast_error } from '@/libs/toast-wrappers';
import { ROUTES } from '@/router/routes';

import { Button } from '@/components/ui/button';
import { FooterButtons, LayoutStep } from '@/components/grading/grade-flow/layouts-flow';
import { DiabeticQuestions } from '@/components/grading/grade-flow/diabetic-retinopathy/diabetic-questions';

export function DrInsightsStep1() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { hasLaterality, left, right, both, forms } = useGradeFlow(
    useShallow((s) => ({
      hasLaterality: s.isLateralityPresentOnImgs,
      left: s.form.grade_left_eye,
      right: s.form.grade_right_eye,
      both: s.form.grade_both_eyes,
      forms: s.forms,
    }))
  );

  const isBlockedByEvidence =
    (hasLaterality &&
      (!left?.evidence_of_dme === undefined || !right?.evidence_of_dme === undefined)) ||
    (!hasLaterality && !both?.evidence_of_dme === undefined);

  const isBlockedByGrade =
    (hasLaterality && (!left?.dr_grade_scale || !right?.dr_grade_scale)) ||
    (!hasLaterality && !both?.dr_grade_scale);

  const handleContinue = () => {
    if (forms.includes('diabetic')) {
      if (isBlockedByEvidence) {
        toast_error(t('grade-error-evidence-dme'));
        return;
      }
      if (isBlockedByGrade) {
        toast_error(t('grade-error-dr-grade'));
        return;
      }
    }

    navigate('../follow-up', { replace: true });
  };

  return (
    <LayoutStep>
      <DiabeticQuestions mode="insights" />
      <FooterButtons>
        <Button variant="ghost-muted" href={ROUTES.INSIGHTS}>
          {t('cancel')}
        </Button>
        <Button onClick={handleContinue}>{t('continue')}</Button>
      </FooterButtons>
    </LayoutStep>
  );
}
